module.exports = __webpack_public_path__ + "static/media/Equipment Truck.efac1407.png";